module.exports = __webpack_public_path__ + "img/logo-cut.517da437.png";